function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { PageHeader, Card } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import Auth from "../../functions/authenticate";
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { repSvc, safe, canManageReport, isPlatformAdmin, errText, runQs, defaultWidth, apiRoot, authHeaders } from "./common";
import { ReportPanel, periodOf, cleanTitle, packSpans, MONTHS_LONG, RANGE_NAMES, fmtDay, fmtSpan, isWholeMonth, isWholeYear } from "./panel";
import ScheduleSheet from "./schedule-sheet";
import { getMyLayout, pinPanels, isPinned, reportComparison } from "../dashboard/layout";
import { Toast } from "../dashboard/edit";

/*
 * Report VIEWER (§223-§226, rebuilt 2026-10-09 to the approved Report /
 * Report2 boards): the saved report as a clean dashboard page.
 * - Follows the top-bar range and comparison (the app standard, not the saved ones); per-panel errors render inline.
 * - Header reads in plain words ("This year, Jan 1 to Oct 9, 2026 ·
 *   updates every time you open it"); actions Download CSV · Share ·
 *   Email it (the schedule sheet; ?schedule=1 opens it on load) · Edit.
 * - Comparison honesty: when the report compares but no panel has data
 *   for the earlier period, ONE note says so and the tiles drop their
 *   per-tile "no comparison" row.
 * - Layout: saved widths on a 6-unit grid, packed in order; a half/third
 *   panel left alone in its row stretches to full width.
 * Styles: sass/v2/_reports-view.scss (rv-*).
 */

const SHARE_API = "https://share.plunk.io";
const btn = "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base";
const btnPrimary = "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary";
class ReportViewerComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "downloadCsv", async () => {
      const range = this.state.range;
      const qs = range ? `?${runQs(range)}` : "";
      try {
        const res = await fetch(`${apiRoot()}/reports/${this.id()}/export.csv${qs}`, {
          headers: authHeaders()
        });
        if (!res.ok) throw new Error(`Download failed (${res.status})`);
        const blob = await res.blob();
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `${(this.state.def || {}).name || "report"}.csv`;
        a.click();
        URL.revokeObjectURL(a.href);
      } catch (e) {
        this.setState({
          note: errText(e, "Download failed.")
        });
      }
    });
    // The sheet owns schedule edits; re-read the definition without a full reload.
    _defineProperty(this, "reloadDef", async () => {
      const def = await safe(repSvc(`/${this.id()}`).getAsync(), null);
      if (this._alive && def) this.setState({
        def
      });
    });
    _defineProperty(this, "mintShare", async () => {
      this.setState({
        shareBusy: true,
        note: null
      });
      try {
        const res = await fetch(`${SHARE_API}/v1/report-links`, {
          method: "POST",
          headers: {
            ...authHeaders(),
            "content-type": "application/json"
          },
          body: JSON.stringify({
            reportId: this.id(),
            days: 30
          })
        });
        const d = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(d.error || `Share failed (${res.status})`);
        if (this._alive) this.setState({
          shareBusy: false,
          shareUrl: d.url
        });
      } catch (e) {
        if (this._alive) this.setState({
          shareBusy: false,
          note: errText(e, "The share link could not be created.")
        });
      }
    });
    _defineProperty(this, "pin", async panels => {
      const items = panels.filter(p => p.id).map(p => ({
        reportId: this.id(),
        panelId: p.id,
        width: this.widthOf(p.id) || defaultWidth(p.kind)
      }));
      if (!items.length) return;
      this.setState({
        pinBusy: true
      });
      try {
        const r = await pinPanels(items);
        const one = panels.length === 1 ? `"${cleanTitle(panels[0].title) || "This chart"}"` : null;
        const text = r.added ? (one ? `Pinned ${one} to your Dashboard.` : `Pinned ${r.added} chart${r.added === 1 ? "" : "s"} to your Dashboard.`) + (r.full ? ` ${r.full} didn't fit: a Dashboard holds up to 24 cards.` : "") : r.full ? "Your Dashboard is full (24 cards). Remove a card to pin more." : "Already on your Dashboard.";
        if (this._alive) this.setState({
          myCards: r.cards,
          pinBusy: false,
          toast: {
            text,
            action: r.added || r.already ? "Open Dashboard" : null
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          pinBusy: false,
          toast: {
            text: errText(e, "Could not pin to your Dashboard. Try again.")
          }
        });
      }
    });
    this.state = {
      def: null,
      run: null,
      registry: null,
      error: false,
      note: null,
      range: getGlobalRange(),
      // driven by the top-bar global period control (§224)
      comp: getGlobalComp(),
      // and its comparison: the app-wide standard (DS 2026-10-22), not the report's saved one
      schedOpen: /[?&]schedule=1/.test(props.location?.search || ""),
      myCards: null,
      pinBusy: false,
      toast: null,
      // My Dashboard pins (mockup C)
      shareOpen: false,
      shareBusy: false,
      shareUrl: null
    };
    this._alive = true;
  }
  id() {
    return String(this.props.params && this.props.params.id || "");
  }
  async componentDidMount() {
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    const [def, registry] = await Promise.all([safe(repSvc(`/${this.id()}`).getAsync(), null), safe(repSvc("/registry").getAsync(), null)]);
    if (!this._alive) return;
    if (!def) {
      this.setState({
        error: true
      });
      return;
    }
    // Saved reports always follow the top bar's global date range, including reports saved on
    // fixed dates (DS 10-12): the saved range is never applied on open.
    this.setState({
      def,
      registry
    });
    this.run(this.state.range);
    getMyLayout().then(l => {
      if (this._alive) this.setState({
        myCards: l.cards
      });
    }).catch(() => {/* pin buttons stay hidden */});
    // Follow the shared top-bar period control (range and comparison) like every other analytics page.
    this._periodTok = subscribePeriod(({
      range,
      comp
    }) => {
      if (!this._alive) return;
      const next = {
        range: range || this.state.range,
        comp: comp || this.state.comp
      };
      if (next.range === this.state.range && next.comp === this.state.comp) return;
      this.setState(next, () => this.run(next.range));
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  async run(range) {
    this._runSeq = (this._runSeq || 0) + 1;
    const seq = this._runSeq;
    this.setState({
      run: null
    });
    const parts = [range ? runQs(range) : "", `comparison=${reportComparison(this.state.comp)}`].filter(Boolean);
    try {
      const run = await repSvc(`/${this.id()}/run?${parts.join("&")}`).getAsync();
      if (this._alive && seq === this._runSeq) this.setState({
        run
      });
    } catch (e) {
      if (this._alive && seq === this._runSeq) this.setState({
        note: errText(e, "The report could not load.")
      });
    }
  }
  // ------------------------------------------------------------ pins
  // "Pin to my Dashboard" per panel, "Pin all charts" for the report (PlunkDocs specs/MY_DASHBOARD_2026-10-22.md, mockup C).

  widthOf(panelId) {
    const p = (this.state.def && this.state.def.panels || []).find(x => x.id === panelId);
    return p && p.width;
  }
  pinAction(p) {
    const {
      myCards,
      pinBusy
    } = this.state;
    if (!myCards || !p.id) return null;
    if (isPinned(myCards, this.id(), p.id)) return /*#__PURE__*/React.createElement("span", {
      className: "rv-pinned"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "check"), "On your Dashboard");
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "rv-pin",
      disabled: pinBusy,
      "aria-label": `Pin ${cleanTitle(p.title) || "this chart"} to my Dashboard`,
      title: "Pin to my Dashboard",
      onClick: () => this.pin([p])
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "push_pin"), "Pin");
  }

  // ------------------------------------------------------------ context

  /** Everything the header, note and panels need to talk about the dates. */
  period() {
    const {
      run,
      def
    } = this.state;
    return periodOf(run, this.state.range || def && def.range);
  }
  subtitle(pd) {
    const {
      run,
      def
    } = this.state;
    const tail = "updates every time you open it";
    if (!run || !pd.from) return def && def.description || `Updates every time you open it`;
    let base;
    if (pd.range === "all_time") base = "All time";else if (isWholeMonth(pd.from, pd.to)) base = `${MONTHS_LONG[pd.from.getMonth()]} ${pd.from.getFullYear()}`;else if (isWholeYear(pd.from, pd.to)) base = String(pd.from.getFullYear());else if (RANGE_NAMES[pd.range]) base = `${RANGE_NAMES[pd.range]}, ${fmtSpan(pd.from, pd.to)}`;else base = fmtSpan(pd.from, pd.to);
    const cmp = pd.comparison ? `, compared with ${pd.prevShort}` : "";
    return `${base}${cmp} · ${tail}`;
  }
  render() {
    const {
      def,
      run,
      registry,
      error,
      note,
      schedOpen,
      shareOpen,
      shareUrl,
      shareBusy
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!def) return /*#__PURE__*/React.createElement(Loader, null);
    const manage = canManageReport(def);
    const canShare = manage || isPlatformAdmin();
    const isPrivate = def.shared === false || def.shared === 0;
    const pd = this.period();
    const panels = run && run.panels || [];
    const spans = packSpans(panels.map((p, i) => p.width || ((def.panels || [])[i] || {}).width || defaultWidth(p.kind)));
    const noComparison = run && pd.comparison && !pd.compareOk && panels.some(p => !p.error && (p.rows || []).length);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view reports-view rv-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Reports"
      }, "Reports"), " \xB7 ", def.name),
      title: def.name,
      subtitle: this.subtitle(pd),
      chips: [isPrivate ? {
        k: "",
        v: "Just you",
        title: "Only you can see this report"
      } : null],
      actions: /*#__PURE__*/React.createElement(React.Fragment, null, this.state.myCards && panels.some(p => p.id && !isPinned(this.state.myCards, this.id(), p.id)) && /*#__PURE__*/React.createElement("button", {
        className: btn,
        disabled: this.state.pinBusy,
        onClick: () => this.pin(panels.filter(p => p.id && !isPinned(this.state.myCards, this.id(), p.id)))
      }, "Pin all charts"), /*#__PURE__*/React.createElement("button", {
        className: btn,
        onClick: this.downloadCsv
      }, "Download CSV"), canShare && /*#__PURE__*/React.createElement("button", {
        className: btn,
        onClick: () => this.setState({
          shareOpen: !shareOpen,
          schedOpen: false
        })
      }, "Share"), manage && /*#__PURE__*/React.createElement("button", {
        className: btn,
        onClick: () => this.setState({
          schedOpen: true,
          shareOpen: false
        })
      }, "Email it"), manage && /*#__PURE__*/React.createElement("button", {
        className: btnPrimary,
        onClick: () => this.props.history.push(`/Reports/edit/${this.id()}`)
      }, "Edit"))
    }), note && /*#__PURE__*/React.createElement("div", {
      className: "wa-notice"
    }, note), schedOpen && manage && /*#__PURE__*/React.createElement(ScheduleSheet, {
      report: def,
      scheduleJson: def.scheduleJson,
      onClose: () => this.setState({
        schedOpen: false
      }),
      onChanged: this.reloadDef
    }), shareOpen && /*#__PURE__*/React.createElement("div", {
      className: "rv-share-card"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Share a link",
      hint: "a read-only page that updates every time it's opened \xB7 links expire after 30 days \xB7 reports only you can see can't be shared"
    }, shareUrl ? /*#__PURE__*/React.createElement("div", {
      className: "rv-share-row"
    }, /*#__PURE__*/React.createElement("code", null, shareUrl), /*#__PURE__*/React.createElement("button", {
      className: btn,
      onClick: () => {
        try {
          navigator.clipboard.writeText(shareUrl);
          this.setState({
            note: "Link copied."
          });
        } catch (e) {/* manual copy */}
      }
    }, "Copy"), /*#__PURE__*/React.createElement("a", {
      className: btn,
      href: shareUrl,
      target: "_blank",
      rel: "noreferrer",
      style: {
        textDecoration: "none"
      }
    }, "Open")) : /*#__PURE__*/React.createElement("button", {
      className: btnPrimary,
      disabled: shareBusy,
      onClick: this.mintShare
    }, shareBusy ? "Creating…" : "Create share link"))), noComparison ? /*#__PURE__*/React.createElement("div", {
      className: "rv-note"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rv-dot"
    }), /*#__PURE__*/React.createElement("span", null, "No comparison this time: there's no data for ", pd.comparison === "previous_year" ? "the same dates last year" : `the period before ${fmtDay(pd.from, true)}`, " to compare with. Comparisons appear on their own once there is.")) : null, this.state.toast && /*#__PURE__*/React.createElement(Toast, {
      text: this.state.toast.text,
      action: this.state.toast.action,
      onAction: () => this.props.history.push("/Dashboard"),
      onClose: () => this.setState({
        toast: null
      })
    }), !run ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement("div", {
      className: "rv-grid"
    }, panels.map((p, i) => /*#__PURE__*/React.createElement("div", {
      key: p.id || i,
      className: "rv-cell",
      style: {
        gridColumn: `span ${spans[i] * 2}`
      }
    }, /*#__PURE__*/React.createElement(ReportPanel, {
      panel: p,
      registry: registry,
      pd: pd,
      action: this.pinAction(p)
    })))));
  }
}
export const ReportViewerViewComponent = withRouter(ReportViewerComponent);
export default {
  ReportViewerViewComponent
};